import { loadLoyaltyIsBenefitEventActive } from ".";
import { EARLY_ACCESS_SALE } from "..";

const loadLoyaltyIsEarlyAccessSaleEventActive = () =>
  loadLoyaltyIsBenefitEventActive(EARLY_ACCESS_SALE);

export default loadLoyaltyIsEarlyAccessSaleEventActive;
